module.exports = __webpack_public_path__ + "img/logo-login.ea745505.png";